module.exports = __webpack_public_path__ + "media/images/Menu burger-1b29cb8923db5300cc4026962a56a6ea.svg";